import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AssessmentModel } from '../../../../../interfaces/AssessmentModel';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CounselingService } from '../../../counseling.service';
import firebase from 'firebase/compat/app';
import Timestamp = firebase.firestore.Timestamp;
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-upcoming-date-assessment',
  templateUrl: './upcoming-date-assessment.component.html',
  styleUrls: ['./upcoming-date-assessment.component.scss']
})
export class UpcomingDateAssessmentComponent implements OnInit,  OnChanges, OnDestroy{
@Input()selectedCentre="All"
  upcomingDate?: string | Timestamp;
  upcomingTimestamp: firebase.firestore.Timestamp | undefined;
  private _destroyed$ = new Subject()
   currentDate = new Date();  // Current date

  upcomingSessions: AssessmentModel[] = [];
todaysdate = new Date().toLocaleDateString()
  // Subtract two months from the current date
   previousDate = new Date();
   threshold = new Date();
  constructor(
    private readonly mFirestore: AngularFirestore,
    private readonly counselingService: CounselingService
  ) {

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedCentre'] && !changes['selectedCentre'].isFirstChange) {
      console.log('Input property changed:', changes['selectedCentre'].currentValue);
      // Perform actions based on the changed value
      this.refresh()
    }
  }
  ngOnInit(): void {
    this.previousDate.setMonth(this.currentDate.getMonth() - 1);
    this.threshold.setMonth(this.currentDate.getMonth() - 1);
    this.threshold.setDate(this.currentDate.getDate()+4)
    this.counselingService.data.pipe(takeUntil(this._destroyed$)).subscribe(data => {
      this.selectedCentre = data as string;


      this.counselingService.getUpcomingAssessMentsList(this.selectedCentre,this.previousDate,this.threshold).pipe(takeUntil(this._destroyed$)).subscribe((res) => {
        this.upcomingSessions = res;
    });

// this.upcomingSessions= this.upcomingSessions.filter(x=>x.dateOfAssessment!.toDate()>this.currentDate)
      // this.upcomingSessions.forEach(r => {
      //
      //   r.dateOfAssessment = this.calculateUpcomingDate(r.dateOfAssessment);
      // });
    });
  }
refresh(){
    alert('refresh clicked')
  this.previousDate.setMonth(this.currentDate.getMonth() - 1);
  this.threshold.setMonth(this.currentDate.getMonth() - 1);
  this.threshold.setDate(this.currentDate.getDate()+4)
  this.counselingService.data.pipe(takeUntil(this._destroyed$)).subscribe(data => {
    this.selectedCentre = data as string;

    this.counselingService.getUpcomingAssessMentsList(this.selectedCentre,this.previousDate,this.threshold).pipe(takeUntil(this._destroyed$)).subscribe((res) => {
      this.upcomingSessions = res;
    });

// this.upcomingSessions= this.upcomingSessions.filter(x=>x.dateOfAssessment!.toDate()>this.currentDate)
    // this.upcomingSessions.forEach(r => {
    //
    //   r.dateOfAssessment = this.calculateUpcomingDate(r.dateOfAssessment);
    // });
  });
}

  calculateUpcomingDate(dateOfAssessment: firebase.firestore.Timestamp | undefined): firebase.firestore.Timestamp {
    const currentDate = dateOfAssessment?.toDate()!
    const upcomingDate = this.previousDate;

    // Add 2 months to the current date
    // upcomingDate.setMonth(currentDate.getMonth() + 2);

    // Create a Firestore timestamp from the upcoming date
    this.upcomingTimestamp = firebase.firestore.Timestamp.fromDate(upcomingDate);

    // Format the upcoming date as a string (e.g., May 29, 2023)
    this.upcomingDate = upcomingDate.toLocaleDateString();

    return this.upcomingTimestamp;
  }

  ngOnDestroy(): void {
this._destroyed$.next('')
    this._destroyed$.complete();
  }
}
